function UserIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4 fill-current" aria-hidden="true">
      <path d="M12 12.2a4.1 4.1 0 1 0-4.1-4.1 4.1 4.1 0 0 0 4.1 4.1Zm0 1.9c-3.16 0-9.5 1.59-9.5 4.75V21h19v-2.15c0-3.16-6.34-4.75-9.5-4.75Z" />
    </svg>
  );
}

function LockIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4 fill-current" aria-hidden="true">
      <path d="M17 8h-1V6.5a4 4 0 1 0-8 0V8H7a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2Zm-6 7.72V17a1 1 0 0 0 2 0v-1.28a2 2 0 1 0-2 0ZM10 8V6.5a2 2 0 1 1 4 0V8Z" />
    </svg>
  );
}

function EyeIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4 fill-current" aria-hidden="true">
      <path d="M12 5c-5.5 0-9.27 5.64-9.43 5.88a2 2 0 0 0 0 2.24C2.73 13.36 6.5 19 12 19s9.27-5.64 9.43-5.88a2 2 0 0 0 0-2.24C21.27 10.64 17.5 5 12 5Zm0 11a4 4 0 1 1 4-4 4 4 0 0 1-4 4Zm0-6.3A2.3 2.3 0 1 0 14.3 12 2.3 2.3 0 0 0 12 9.7Z" />
    </svg>
  );
}

function TextField({
  type = 'text',
  placeholder,
  value,
  onChange,
  icon = 'user',
  showAction = false,
  actionLabel = '',
  onActionClick,
  name,
  autoComplete,
  id,
}) {
  const leadingIcon = icon === 'lock' ? <LockIcon /> : <UserIcon />;

  return (
    <div className="flex h-11 items-center overflow-hidden rounded-[4px] border border-eva-border bg-[#dfe8f5] shadow-field transition focus-within:border-[#b9c7db]">
      <span className="flex h-full w-11 items-center justify-center border-r border-[#c7d1e0] bg-[#eef2f7] text-eva-icon">
        {leadingIcon}
      </span>

      <input
        id={id}
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete={autoComplete}
        className="h-full flex-1 border-0 bg-transparent px-3 font-login text-[14px] text-[#0f172a] outline-none placeholder:text-[#6b7280]"
      />

      {showAction ? (
        <button
          type="button"
          onClick={onActionClick}
          aria-label={actionLabel}
          className="flex h-full w-11 items-center justify-center border-l border-[#c7d1e0] bg-[#eef2f7] text-eva-icon transition hover:bg-[#e7ebf2]"
        >
          <EyeIcon />
        </button>
      ) : null}
    </div>
  );
}

export default TextField;
